var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiraDuvidas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tira-duvidas",
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #050007;\n        stroke-linecap: round;\n        stroke-width: 1px;\n        stroke-dasharray: 0.001 2;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    className: "cls-1",
    d: "M300,213a88,88,0,1,1-88,88A88,88,0,0,1,300,213Zm-49,88,17-16,22,22,44-44,17,16-61,61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Forma_5",
    "data-name": "Forma 5",
    className: "cls-1",
    d: "M10,301l60-49S15.919,199,38,117c0,0,34.253-105.477,142-106,0,0,156.123,2.113,139,178,0,0-121-8.5-130,113ZM145,124h23s0.712-12,11-12c0,0,10.712-.831,11,12,0,0-1.288,8.919-12,13,0,0-9,2.419-9,16v26h21V156s0.962-6.081,7-7c0,0,14.712-6.081,15-16,0,0,1.462-11.831-1-20,0,0-3.538-20.081-31-24C180,89,146.393,87.743,145,124Zm23,77v22h22V201H168Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiraDuvidas);
export default __webpack_public_path__ + "static/media/tira-duvidas.91e42dbcb219e517fddf7e7b83353d23.svg";
export { ForwardRef as ReactComponent };